import { createContext } from "react";

const BrandGapSubFilter = createContext([]);

export default BrandGapSubFilter;
